import { Fragment } from 'react'

import { useBrowserGlobalListener, useCaptureScreen } from '#/hooks'

import { Footer } from '../footer/footer'
import { Header } from '../header/header'
import { Tab } from '../tabs/tabs'

export const AxieJam = () => {
  useBrowserGlobalListener()

  useCaptureScreen('Axie Game Jam 2023')

  return (
    <Fragment>
      <Header />
      {/* <Register /> */}
      <Tab />
      <Footer />
    </Fragment>
  )
}
